import { Card, Container } from "react-bootstrap";

const FormCard = ({...props}) => {
    return ( 
        <Container className="py-1 d-flex justify-content-center align-items-center">
            <Card className="border-0 w-75">
                <h3 className="mb-5 text-center">{props.title}</h3>
                {props.children}
            </Card>
        </Container>
     );
}
 
export default FormCard;